document.addEventListener('DOMContentLoaded', function() {
  cDrawerPosFixTrigger();
  cTabChangeTrigger();
  // cWorkshopTrigger();
  cModalSliderTrigger();
  cSlideProductTorigger();
  cSmoothScrollTrigger();
  cSlideImgTorigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      cDrawerPosFixTrigger();
      cTabChangeTrigger();
      // cWorkshopTrigger();
      cModalSliderTrigger();
      cSlideProductTorigger();
      cSmoothScrollTrigger();
      cSlideImgTorigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      cDrawerPosFixTrigger();
      cTabChangeTrigger();
      // cWorkshopTrigger();
      cModalSliderTrigger();
      cSlideProductTorigger();
      cSmoothScrollTrigger();
      cSlideImgTorigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      cDrawerPosFixTrigger();
      cTabChangeTrigger();
      // cWorkshopTrigger();
      cModalSliderTrigger();
      cSlideProductTorigger();
      cSmoothScrollTrigger();
      cSlideImgTorigger();
    });
}


/****************************************
    ドロワーメニューの開閉位置調整のJS
****************************************/
function cDrawerPosFixTrigger() {
    if (document.querySelector('.shopify-section--header') !== null) {
        cDrawerPosFix();
    }
};

function cDrawerPosFix() {
    function handleMediaQueryChange(e) {
        if (e.matches) {
            const cAnnouncement = document.querySelector('.shopify-section--announcement-bar');
            const cAnnouncementBar = document.querySelector('.c-announcement-bar');
            const cHeader = document.querySelector('.shopify-section--header');
          
            let cAncHeight = 0;
            if (cAnnouncement !== null) {
                cAncHeight = cAnnouncement.offsetHeight;
            }
            let cHeaderHeight = cHeader.offsetHeight;

            function updateDrawerPos() {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;

                if (cAnnouncementBar && cAnnouncementBar.classList.contains('c-announcement-bar__sticky')) {
                    document.documentElement.style.setProperty('--c-drawer-pos', `${cHeaderHeight + cAncHeight}px`);
                } else {
                    if (scrollTop > cAncHeight) {
                        document.documentElement.style.setProperty('--c-drawer-pos', `${cHeaderHeight}px`);
                    } else {
                        const difference = cAncHeight - scrollTop;
                        document.documentElement.style.setProperty('--c-drawer-pos', `${cHeaderHeight + difference}px`);
                    }
                }
            }
            updateDrawerPos();

            window.addEventListener('scroll', debounce(updateDrawerPos, 200));

            const drawerBtn = document.querySelector('.c-header__sidebarbtn');

            if (drawerBtn) {
                const observerCallback = function(mutationsList) {
                    for (let mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                            const isExpanded = drawerBtn.getAttribute('aria-expanded') === 'true';
                            if (isExpanded) {
                                document.body.classList.add('c-open-drawer');
                            } else {
                                document.body.classList.remove('c-open-drawer');
                            }
                        }
                    }
                };
        
                const observerOptions = {
                    attributes: true,
                    attributeFilter: ['aria-expanded']
                };
        
                const observer = new MutationObserver(observerCallback);
                observer.observe(drawerBtn, observerOptions);
            }
          
        } else {
            document.documentElement.style.setProperty('--c-drawer-pos', '0px');
        }
    }
    
    const mediaQuery = window.matchMedia("(max-width: 699px)");
    mediaQuery.addListener(handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    window.addEventListener('resize', debounce(() => {
        handleMediaQueryChange(mediaQuery);
    }, 200));
}


/****************************************
    タブ切り替えセクション
****************************************/
function cTabChangeTrigger() {
    if (document.querySelectorAll('.c-tab__section').length) {
        cTabChange();
    }
};

function cTabChange() {
    const tabList = document.querySelectorAll('.c-tab__tablist');
    const tabContent = document.querySelectorAll('.c-tab__content');

    function activateTab(tab) {
        document.querySelectorAll('.is-active')[0].classList.remove('is-active');
        tab.classList.add('is-active');
        document.querySelectorAll('.is-show')[0].classList.remove('is-show');
        const aryTabs = Array.prototype.slice.call(tabList);
        const index = aryTabs.indexOf(tab);
        tabContent[index].classList.add('is-show');
    }

    tabList.forEach((tab, i) => {
        const link = tab.querySelector('a');
        tab.addEventListener('click', () => {
            if (link) {
                e.preventDefault();
                setTimeout(() => {
                    activateTab(tab);
                    window.location.href = link.href;
                }, 1000);
            } else {
                activateTab(tab);
            }
        });
    });
};


/****************************************
    ワークショップ・編み会
****************************************/
// function cWorkshopTrigger() {
//     if (document.querySelectorAll('.c-workshop__section.c-automatically').length) {
//         cWorkshop();
//     }
// };

// function cWorkshop() {
//     const workshopEls = document.querySelectorAll('.c-workshop__one');

//     workshopEls.forEach(function(workshop) {
//         const dateEl = workshop.querySelector('.c-workshop__date__input').value;
//         const activeStatusEl = workshop.querySelector('.c-workshop__status.is-active');
//         const endedStatusEl = workshop.querySelector('.c-workshop__status.is-ended');

//         if (dateEl) {
//             const dateText = dateEl.trim();
//             const dateMatch = dateText.match(/(\d{4})\/(\d{2})\/(\d{2}) (\d{1,2}:\d{1,2})-(\d{1,2}:\d{1,2})/);

//             if (dateMatch) {
//                 const year = dateMatch[1];
//                 const month = dateMatch[2];
//                 const day = dateMatch[3];
//                 let startTime = dateMatch[4];

//                 startTime = startTime.split(':').map(part => part.padStart(2, '0')).join(':');

//                 const startDateTime = new Date(`${year}-${month}-${day}T${startTime}:00`);
//                 const start = startDateTime.getTime();

//                 const now = new Date();
//                 const today = now.getTime();

//                 if (today > start) {
//                     activeStatusEl.classList.remove('is-active');
//                     endedStatusEl.classList.add('is-active');
//                 } else {
//                     activeStatusEl.classList.add('is-active');
//                     endedStatusEl.classList.remove('is-active');
//                 }
//             }
//         }
//     });
// }


/****************************************
    STOREセクションモダール内スライダー
****************************************/
function cModalSliderTrigger() {
    const wrappers = document.querySelectorAll('.c-modal__wrapper');
    if (wrappers.length > 0) {
        wrappers.forEach(wrapper => {
            cModalSlider(wrapper);
        });
    }
}

function cModalSlider(wrapper) {
    const prevButton = wrapper.querySelector('.c-modal__prev');
    const nextButton = wrapper.querySelector('.c-modal__next');
    const slides = wrapper.querySelectorAll('.c-slide');

    prevButton.addEventListener('click', function() {
        cSliderFnc(0);
    });
    nextButton.addEventListener('click', function() {
        cSliderFnc(1);
    });

    function cSliderFnc(index) {
        slides.forEach(slide => slide.classList.remove('is-active'));
        slides[index].classList.add('is-active');

        if (index === 0) {
            prevButton.classList.add('is-hidden');
            nextButton.classList.remove('is-hidden');
        } else if (index === 1) {
            prevButton.classList.remove('is-hidden');
            nextButton.classList.add('is-hidden');
        }
    }
}


/****************************************
    メインビジュアルのJS
****************************************/
function cSlideImgTorigger() {
    if (document.querySelectorAll('.c-mv__section').length) {
        cSlideImg();
    }
};

function cSlideImg() {
  $('.c-mv__section .slider').each(function() {
      const $slick = $(this);
      $slick.slick({
          autoplay: true,
          autoplaySpeed: 6000,
          arrows: true,
          dots: true,
          centerMode: true,
          centerPadding: '29%',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse"><span class="c-arrow__svg"></span></button>',
          nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal"><span class="c-arrow__svg"></span></button>',
          responsive: [{
              breakpoint: 699,
              settings: {
                  centerPadding: '5%',
              }
          }]
      });
  });
}


/****************************************
    商品一覧セクションのJS
****************************************/
function cSlideProductTorigger() {
    if (document.querySelectorAll('.c-newitems__section').length) {
        cSlideProduct();
    }
};

function cSlideProduct() {
  $('.c-newitems__section').each(function() {
      const $slick = $(this).find('.c-newitems__inner.slider');
      const slickWrapper = $(this).find('.c-newitems__wrapper');

      const productNum = $slick.data('productNum');
      const slideNum = $slick.data('slideNum');

      const mediaQuery999 = window.matchMedia('(max-width: 999px)');
      const mediaQuery679 = window.matchMedia('(max-width: 679px)');
      const mediaQuery479 = window.matchMedia('(max-width: 479px)');

      function handleMediaQueryChange() {
          let maxProductNum;
          if (mediaQuery479.matches) {
              maxProductNum = 2;
          } else if (mediaQuery679.matches) {
              maxProductNum = 3;
          } else if (mediaQuery999.matches) {
              maxProductNum = 4;
          } else {
              maxProductNum = 4;
          }

          if (productNum <= maxProductNum || slideNum <= maxProductNum) {
              slickWrapper.addClass('c-stack-slick');
          } else {
              slickWrapper.removeClass('c-stack-slick');
          }
      }

      handleMediaQueryChange();
      mediaQuery999.addListener(handleMediaQueryChange);
      mediaQuery679.addListener(handleMediaQueryChange);
      mediaQuery479.addListener(handleMediaQueryChange);

      $slick.not('.slick-initialized').slick({
          autoplay: false,
          arrows: true,
          dots: false,
          slidesToShow: 5.25,
          slidesToScroll: 1,
          infinite: false,
          prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse"><span class="c-arrow__svg"></span></button>',
          nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal"><span class="c-arrow__svg"></span></button>',
          responsive: [
              {
                  breakpoint: 1000,
                  settings: {
                      slidesToShow: 4.4,
                  }
              },
              {
                  breakpoint: 680,
                  settings: {
                      slidesToShow: 3.4,
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 2.4,
                  }
              }
          ]
      });
  });
}


/****************************************
    トップへ戻るボタン
****************************************/
function cSmoothScrollTrigger() {
    if (document.querySelectorAll('.c-smoothscroll').length) {
        cSmoothScroll();
    }
};

function cSmoothScroll() {
    let viewOffset = 0;
    const smoothScrollEl = document.querySelector('.c-smoothscroll');

    function viewSmoothScroll() {
        if (window.pageYOffset > viewOffset) {
            smoothScrollEl.classList.add('c-view');
        } else if (window.pageYOffset < viewOffset) {
            smoothScrollEl.classList.remove('c-view');
        }
    }

    window.addEventListener('scroll', function() { 
        viewSmoothScroll();
    });

    smoothScrollEl.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });
}


/****************************************
    ドロワーメニューの開閉JS
****************************************/
$(document).ready(function() {
    $(document).on('click', '.c-toggle__title', function() {
        $(this).next('.c-toggle__content').slideToggle();
        $(this).toggleClass('is-active');
    });
});
